import React from "react";
import PrimaryHeading from "./custom-ui/PrimaryHeading";
import trackChart from "../assets/images/webp/track-chart.webp";
import trackChartSm from "../assets/images/webp/track-chart-sm.webp";
import trackChartWtf from "../assets/images/webp/track-chart-wtf.webp";
import duncanFace from "../assets/images/webp/chart-icon.webp";
import Paragraph from "./custom-ui/Paragraph";
import  dexscreener from "../assets/images/svg/dexscreener.svg"
import dextools from "../assets/images/svg/dextools.svg"

function TrackChart() {
  return (
    <div
      id="track-chart"
      className="2xl:max-w-[1296px] xl:max-w-[1240px] lg:px-5 md:px-8 px-5 mx-auto container 2xl:pt-[100px] lg:pt-20 md:pt-16 sm:pt-12 pt-9 custom-1700:pb-[100px] 2xl:pb-20 lg:pb-14 md:pb-12 sm:pb-10 pb-9"
    >
      {/* Primary Heading */}
      <PrimaryHeading
        className="text-center sm:max-w-[unset] max-w-[243px] mx-auto relative z-10"
        children="$Dunce Track Chart"
      />

      <div className="lg:pt-[60px] md:pt-12 sm:pt-8 pt-5 lg:pe-5 2xl:pe-0">
        <div className="relative">
          {/* Main Track Chart Image */}
          <img
            src={trackChart}
            alt="track-chart-image"
            className="w-full sm:block hidden 2xl:shadow-xlPurpleShadow bg-dark-purple xl:shadow-lgPurpleShadow shadow-mdPurpleShadow md:rounded-28 rounded-2xl border-2 border-dark-purple hover:shadow-none transition-all duration-300 ease-in-out hover:translate-x-2 hover:translate-y-2 min-h-[350px]"
          />
          <img
            src={trackChartSm}
            alt="track-chart-image"
            className="w-full sm:hidden bg-dark-purple block  2xl:shadow-xlPurpleShadow xl:shadow-lgPurpleShadow shadow-mdPurpleShadow md:rounded-28 rounded-2xl border-2 border-dark-purple hover:shadow-none transition-all duration-300 ease-in-out hover:translate-x-2 hover:translate-y-2 min-h-[350px]"
          />

          {/* Overlay Image - WTF */}
          <img
            src={trackChartWtf}
            alt="track-cahrt-wtf"
            className="xl:w-[214px] lg:w-[190px] md:w-[150px] sm:w-[120px] w-[90px] xl:h-[233px] lg:h-[195px] md:h-[155px] sm:h-[125px] h-[99px] absolute -top-14 sm:-top-20 lg:-top-40 xl:right-5 sm:right-2 -right-2"
          />

          {/* Overlay Image - Duncan's Face */}
          <img
            src={duncanFace}
            alt="duncan-face-image"
            className="xl:w-[148px] lg:w-[90px] md:w-[50px] sm:w-[50px] rotate-[-9deg] w-[57px] xl:h-[234px] lg:h-[120px] md:h-[80px] sm:h-[65px] h-[70px] absolute top-16 left-1/2 -translate-x-1/2"
          />
        </div>

        {/* Description Paragraph 1 */}
        <Paragraph
          className="text-center lg:ps-5 2xl:ps-0 lg:pt-[90px] md:pt-20 sm:pt-14 pt-9 max-w-[1166px] mx-auto"
          children="Track $DUNCE on Dexscreener and Dextools"
        />
        {/* Description Paragraph 1 */}
        <div className="lg:pt-[50px] md:pt-12 sm:pt-10 py-8 sm:flex-row flex-col flex max-w-[714px] justify-center md:gap-[30px] gap-6 mx-auto">
          <a
            href="https://dexscreener.com/"
            target="_blank"
            className="flex gap-[15px] items-center py-[15px] px-[38px] hover:translate-y-2 hover:shadow-none transition-all duration-300 ease-in-out bg-dark-purple rounded-18 border-2 border-pink-bg sm:w-[324px] w-[250px] mx-auto h-[78px] justify-center shadow-roadmapArrowShadow"
          >
            <img src={dexscreener} alt="dexscreener-icon" />
            <span className="text-white sm:text-custom-4xl text-2xl leading-100 [text-shadow:2px_2px_0px_#000000]">
              dexscreener
            </span>
          </a>
          <a
            href="https://www.dextools.io/app/en/hot-pairs"
            target="_blank"
            className="flex gap-[15px] items-center py-[15px] px-[38px] hover:translate-y-2 hover:shadow-none transition-all duration-300 ease-in-out bg-light-purple rounded-18 border-2 border-dark-purple sm:w-[324px] w-[250px] mx-auto h-[78px] justify-center shadow-roadmapArrowShadow"
          >
            <img src={dextools} alt="dextools-icon" />
            <span className="text-white sm:text-custom-4xl text-2xl leading-100 [text-shadow:2px_2px_0px_#000000]">
              dextools
            </span>
          </a>
        </div>
        <Paragraph
          className="text-center lg:ps-5 2xl:ps-0 lg:pt-14 md:pt-12 pt-9 max-w-[1166px] mx-auto"
          children="Stay up-to-date with Dunce Coin’s performance! Our real-time tracking chart ensures you’re always in the loop about the latest price movements."
        />
      </div>
    </div>
  );
}

export default TrackChart;
